import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import { onActivated, ref } from 'vue-demi'
// import wx from 'weixin-js-sdk'
// import { wxAuth } from './apis/weixin'
// import { getQueryString } from './utils/common'

// import { apiGetToken } from './apis/public/oauth'

// import { useStore } from './utils/db'
// import router from './router'

// import { useRouter } from 'vue-router'
// const r = useRouter()

// const store = useStore()
// console.log('wx==>', wx)
// // 网页授权
// // 1. 判断是否已经拥有openid，有则跳过授权步骤，无则进入授权流程
// // 2. ssid为后端缓存的key，用于获取用户的openid
// const openId = ref('')
// const weixinAuth = async () => {
//   // 获取url中ssid
//   const ssid = getQueryString('ssid')
//   const q: any = {}
//   if (ssid) q.ssid = ssid

//   // 请求授权接口
//   const res = await wxAuth({ ssid: ssid })
//   // console.log('===>res', res)
//   if (res.code == 302) {
//     location.href = res.data.redirect_url
//   } else {
//     store.setUserInfo(res.data)
//     console.log('显示本地保存-userinfo', store.getUserInfo)
//     // getToken()
//   }
// }


// weixinAuth()

// call

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})